import React from 'react';
import cx from 'classnames';
import styles from './index.less';
import Link from '../link';

const HoverBtn = ({ className, normalImg, hoverImg, children, ...props }) => {
  return (
    <Link className={cx(styles.hoverBtnWrap, className)} {...props}>
      <img className={'btn-normal'} src={normalImg} alt="" />
      <img className={'btn-hover'} src={hoverImg} alt="" />
      {children}
    </Link>
  );
};

export default HoverBtn;
